var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygonObject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 403,
    height: 203,
    viewBox: "0 0 403 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M84.1429 22.5C92.1814 8.57695 107.037 6.30518e-07 123.114 -8.68407e-07L279.153 -8.31927e-06C295.229 -2.1888e-06 310.085 8.57695 318.124 22.5L396.143 157.633C404.181 171.556 404.181 188.71 396.143 202.633L318.124 337.767C310.085 351.69 295.229 360.267 279.153 360.267L123.114 360.267C107.037 360.267 92.1814 351.69 84.1429 337.767L6.12366 202.633C-1.91481 188.71 -1.91481 171.556 6.12366 157.633L84.1429 22.5Z",
    fill: "url(#paint0_linear_1271_92615)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1271_92615",
    x1: 51.8148,
    y1: 337.506,
    x2: 355.795,
    y2: 63.7325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B50E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA6161"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonObject);
export default __webpack_public_path__ + "static/media/polygon-object.59e7dea0a1bb763168beadea745b5ffd.svg";
export { ForwardRef as ReactComponent };